<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <h1>新闻动态</h1>
        <div class="tabs">
          <div
            class="tab-item"
            :class="{ active: type === 'gongsi' }"
            @click="typeChange('gongsi')"
          >
            <div class="tag"></div>
            公司动态
          </div>
          <div
            class="tab-item"
            :class="{ active: type === 'hangye' }"
            @click="typeChange('hangye')"
          >
            <div class="tag"></div>
            行业资讯
          </div>
        </div>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">首页 > 新闻动态 > {{ lastStep }}</div>
    </div>

    <section class="section news">
      <div class="section-container">
        <div class="list">
          <div
            class="list_item"
            v-for="(item, index) in newsList"
            :key="index"
            :class="{ hasImage: item.image }"
            :style="`backgroundImage:index === 0 ? '' : url(${item.image})`"
          >
            <div class="shime">
              <div class="img_wrapper" :style="`backgroundImage:url(${item.image})`" v-if="index === 0"></div>
              <div class="news_content">
                <div class="title">{{ item.title }}</div>
                <div class="desc text-ellipsis-two">
                  {{ item.introduction }}
                </div>
                <div class="bottom">
                  <div class="date">
                    <div class="day">{{ item.date }}</div>
                    <div class="year_month">{{ item.year_month }}</div>
                  </div>
                  <div class="learn-more-btn" @click="goToNewsDetail(item.id)">
                    查看详情
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分页 -->
    <el-pagination 
      v-if="total"
      layout="prev, pager, next" 
      :total="total"
      :current-page="pageIndex"
      :page-size="pageSize"
      @current-change="(val) => { pageIndex = val; getNewsList() }"
    >
    </el-pagination>

    <!-- 联系我们 -->
    <contactModule />
    <Footer />
  </div>
</template>

<script>
import contactModule from "../components/contactModule.vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

import NumberCounter from "../components/NumberCounter.vue";
import HorizontalScroll from "../components/HorizontalScroll.vue";

import newsImage from "../static/news/list2.png";

import { NewsAPI } from "../api/api";
import { imgBaseUrl } from "../api/config";
import dayjs from "dayjs";


export default {
  name: "News",
  components: {
    Header,
    Footer,
    NumberCounter,
    HorizontalScroll,
    contactModule,
  },
  computed: {
    lastStep() {
      let mapObj = {
        gongsi: "公司动态",
        hangye: "行业资讯",
      };
      return mapObj[this.type];
    },
  },

  created() {
    console.log(99999, this.$route.query);
    // this.type = this.$route.query.type || "gongsi";
    // this.getNewsList();
  },
  activated() {
    this.type = this.$route.query.type || "gongsi";
    this.getNewsList();
  },

  data() {
    return {
      type: "gongsi",

      newsList: [],
      total: 0,
      pageIndex: 1,
      pageSize: 5,
    };
  },
  methods: {
    typeChange(type){
      this.type = type
      this.getNewsList()
    },
    getNewsList() {
      let mapObj = {
        gongsi: 2,
        hangye: 3,
      };
      NewsAPI.getContentList({
        current: this.pageIndex,
        size: this.pageSize,
        categoryId: mapObj[this.type], // 2 公司动态 3 行业资讯,
      }).then((res) => {
        console.log('新闻列表', res);
        this.newsList = (res.records || []).map(item =>{
          return {
            ...item,
            date: dayjs(item.createTime).format('DD'),
            year_month: dayjs(item.createTime).format('YYYY-MM'),
            image: item.coverImage ? `${imgBaseUrl}${item.coverImage}` : ''
          };
        });
        this.total = res.total
      });
    },
    goToNewsDetail(id) {
      this.$router.push(`/news/${id}`);
    },
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    padding-bottom: 100px;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/news/head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      h1 {
        margin-top: 275px;
        font-size: 48px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        // width: 50%;
        width: 1400px;
        margin: 0 40px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 62px;
          line-height: 62px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          background: #f9fafc;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 40px !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 50px;
  }

  .news {
    padding-bottom: 0 !important;

    .list {
      display: flex;
      flex-wrap: wrap;
      gap: 30px;
      padding: 20px;
      margin: 0 auto;

      .list_item {
        line-height: 1;
        flex: 1 0 calc(50% - 15px);
        // background: rgba(249, 250, 252, 0);
        border-radius: 8px;
        border: 1px solid #eff0f3;
        background-size: 100% 100%;
        overflow: hidden;

        .shime {
          display: flex;
          align-items: center;
          gap: 60px;
          padding: 40px;
        }

        &:nth-of-type(1) {
          flex: 0 0 100%;
          background: #ecf3fd;

          .img_wrapper {
            border-radius: 8px;
            width: 631px;
            height: 368px;
            background: url("../static/news/list1.png") center/cover no-repeat;
          }

          .news_content {
            flex: 1;
          }
        }

        // &:nth-of-type(3) {
        //   background: url("../static/news/list2.png") center/cover no-repeat;
        // }

        .title {
          margin-bottom: 34px;
          font-weight: 600;
          font-size: 22px;
          color: #000000;
        }

        .desc {
          margin-bottom: 142px;
          font-size: 14px;
          color: #888888;
        }

        .bottom {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;

          .date {
            .day {
              margin-bottom: 10px;
              font-weight: 600;
              font-size: 52px;
              color: #9d9d9d;
            }

            .year_month {
              font-size: 16px;
              color: #9d9d9d;
            }
          }

          .learn-more-btn {
            display: inline-flex;
            align-items: center;
            line-height: 1;
            padding: 12px 20px;
            font-size: 16px;
            background: #f9fafc;
            border-radius: 50px;
            color: #888888;

            .circle {
              margin-left: 24px;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: url("../static/job/arrow_right_default.png")
                center/cover no-repeat;
            }
          }
        }
      }

      .list_item:hover {
        .shime {
          background: #0248ff;
        }

        .title {
          color: #fff;
        }

        .desc {
          color: #fff;
        }

        .bottom {
          .date {
            .day {
              color: #fff;
            }

            .year_month {
              color: #fff;
            }
          }

          .learn-more-btn {
            background: #f9fafc;
            color: #0248ff;

            .circle {
              background: url("../static/home/circle_arrow_right_light.png")
                center/cover no-repeat;
            }
          }
        }
      }
      .hasImage {
        // 出事的时候隐藏图片
        background-position: 1000px;
        background-repeat: no-repeat;
      }
      .hasImage:hover {
        background-position: 0;
        .shime {
          background: linear-gradient(to bottom, #0248ff, transparent);
          // opacity: 0.8;
        }
      }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 72px 0;

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      width: 48px;
      height: 48px;
      background: #f8f8f8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      color: #0248ff;
    }

    ::v-deep .el-pager {
      margin: 0 32px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
    }

    ::v-deep .btn-prev:hover,
    ::v-deep .btn-next:hover,
    ::v-deep .el-pager li:not(.disabled):hover {
      background: #ecf3fd;
      color: #323232;
    }

    ::v-deep .el-pager li.active {
      background: #ecf3fd;
      color: #323232;
    }
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
// mobile
@media (max-width: 750px) {
  .section {
    padding-bottom: 50px;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    background: url("../static/news/head_bg.png") center/cover no-repeat;
    // background: url("../static/news/head_bg.png");
    // background-size: 100% 100%;

    .hero-overlay {
      padding-top: 55px;
      h1 {
        line-height: 174px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
      }

      .tabs {
        position: absolute;
        bottom: 0;
        width: calc(100% - 48px);
        display: flex;
        margin: 0 24px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);

        .tab-item {
          position: relative;
          height: 31px;
          line-height: 31px;
          text-align: center;
          flex: 1;
          font-weight: 600;
          font-size: 12px;
          color: #000000;
          background: #f9fafc;

          .tag {
            position: absolute;
            top: 0;
            width: 100%;
            height: 1px;
            background: #fff;
          }
        }

        .active {
          color: #0248ff;
          background: #fff;

          .tag {
            background: #0248ff;
          }
        }
      }
    }
  }

  .navigation {
    padding: 0 !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 0px;
  }

  .news {
    padding-bottom: 0 !important;

    .list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 0 auto;

      .list_item {
        line-height: 1;
        // flex: 1 0 calc(50% - 15px);
        // background: rgba(249, 250, 252, 0);
        border-radius: 4px;
        border: 1px solid #eff0f3;
        background-size: 100% 100%;
        overflow: hidden;

        .shime {
          display: flex;
          align-items: center;
          gap: 60px;
          padding: 20px;
          .news_content{
            width: 100%;
          }
        }

        &:nth-of-type(1) {
          flex: 0 0 100%;
          background: #ecf3fd;

          .img_wrapper {
            display: none;
            border-radius: 8px;
            width: 631px;
            height: 368px;
            background: url("../static/news/list1.png") center/cover no-repeat;
          }

          .news_content {
            flex: 1;
          }
        }

        // &:nth-of-type(3) {
        //   background: url("../static/news/list2.png") center/cover no-repeat;
        // }

        .title {
          margin-bottom: 17px;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }

        .desc {
          margin-bottom: 30px;
          font-size: 12px;
          color: #888888;
        }

        .bottom {
          width: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;

          .date {
            .day {
              margin-bottom: 10px;
              font-weight: 600;
              font-size: 26px;
              color: #9d9d9d;
            }

            .year_month {
              font-size: 12px;
              color: #9d9d9d;
            }
          }

          .learn-more-btn {
            display: inline-flex;
            align-items: center;
            line-height: 1;
            padding: 6px 10px;
            font-size: 12px;
            background: #f9fafc;
            border-radius: 50px;
            color: #888888;

            .circle {
              margin-left: 24px;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background: url("../static/job/arrow_right_default.png")
                center/cover no-repeat;
            }
          }
        }
      }

      // .list_item:hover {
      //   .shime {
      //     background: #0248ff;
      //   }

      //   .title {
      //     color: #fff;
      //   }

      //   .desc {
      //     color: #fff;
      //   }

      //   .bottom {
      //     .date {
      //       .day {
      //         color: #fff;
      //       }

      //       .year_month {
      //         color: #fff;
      //       }
      //     }

      //     .learn-more-btn {
      //       background: #f9fafc;
      //       color: #0248ff;

      //       .circle {
      //         background: url("../static/home/circle_arrow_right_light.png")
      //           center/cover no-repeat;
      //       }
      //     }
      //   }
      // }
      .hasImage {
        // 出事的时候隐藏图片
        background-position: 1000px;
        background-repeat: no-repeat;
      }
      // .hasImage:hover {
      //   background-position: 0;
      //   .shime {
      //     background: linear-gradient(to bottom, #0248ff, transparent);
      //     // opacity: 0.8;
      //   }
      // }
    }
  }

  .el-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 0;
    transform: scale(0.6);

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
      width: 48px;
      height: 48px;
      background: #f8f8f8;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #888;
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
      color: #0248ff;
    }

    ::v-deep .el-pager {
      margin: 0 32px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
    }

    ::v-deep .btn-prev:hover,
    ::v-deep .btn-next:hover,
    ::v-deep .el-pager li:not(.disabled):hover {
      background: #ecf3fd;
      color: #323232;
    }

    ::v-deep .el-pager li.active {
      background: #ecf3fd;
      color: #323232;
    }
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
</style>
